/*
 * File: AppointmentLinks.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Returns the links for the appointment details pages
 */
import React from "react";
import UILinkList from "components/ui/UILinkList";
import PropTypes from "prop-types";

const AppointmentLinks = ({ appointmentId }) => {
  const appointmentUrl = "/appointments/" + appointmentId;

  const links = [
    {
      primaryString: "Last & Next Appointments",
      url: appointmentUrl + "/last-next"
    },
    {
      primaryString: "Follow-Ups",
      url: appointmentUrl + "/followups"
    },
    {
      primaryString: "Referrals",
      url: appointmentUrl + "/referrals"
    },
    {
      primaryString: "Treatments Planned",
      url: appointmentUrl + "/treatments-planned"
    },
    {
      primaryString: "Insurance",
      url: appointmentUrl + "/insurance"
    },
    {
      primaryString: "Balances",
      url: appointmentUrl + "/balances"
    }
  ];

  return <UILinkList includeFabPadding links={links} />;
};

AppointmentLinks.propTypes = {
  appointmentId: PropTypes.number
};

export default AppointmentLinks;
